import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {en, zhHans} from '../locale/'

Vue.use(VueI18n)

function loadLocaleMessages() {
    let messages: any = [en, zhHans]

    messages['en'] = en
    messages['zhHans'] = zhHans

    return messages
}

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'zhHans',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zhHans',
    messages: loadLocaleMessages()
})